export default __webpack_public_path__ + "static/media/trampapo_02_22.c2c6d131.jpg";